import { useMemo } from "react";
import { localStorageInstance } from "../../utils/localStorage";
import { currentUserId, currentUserToken } from "../../utils/constants";
import {
  getAuthState,
  shouldBypassProtectedRoute,
} from "../utils/routeUtils";

export function useProtectedRoute(pathname) {
  return useMemo(() => {
    if (shouldBypassProtectedRoute(pathname)) {
      localStorageInstance.clear();
      return {
        shouldRenderOutlet: true,
        shouldRedirect: false,
      };
    }

    const auth = getAuthState({
      token: currentUserToken(),
      userId: currentUserId(),
    });

    return {
      shouldRenderOutlet: !auth,
      shouldRedirect: auth,
    };
  }, [pathname]);
}
